<template>
  <div
    class="ds-control ds-form-item ds-audit-state"
    :class="getCss"
  >
    <template v-if="simple&&readOnly&&!isDesign">
      <DsfTextProxy
        v-model="value"
        v-bind="_self.$props"
      ></DsfTextProxy>
      <span v-if="value != ''">{{ append }}</span>
      <slot name="error">
        <div
          v-if="errors.length>0"
          class="ds-error-text"
        >{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-else>
      <DsfFieldLabel
        v-if="showLabel"
        :mode="showDataCaptionMode"
        :style="getLabelWidthStyle()"
        :show-icon="showDataCaptionIcon"
        :trigger="showDataCaptionTrigger"
        :data-caption="dataCapion"
        :is-design="isDesign"
        :owner="_self"
      >
        {{$t(label)}}
      </DsfFieldLabel>
      <div
        class="ds-form-block"
        :style="getFormItemBlockMarginLeft()"
      >
        <!--只读状态只显示div-->
        <div
          v-if="readOnly"
          class="ds-form-readonly"
        >
          <DsfTextProxy
            v-model="value"
            v-bind="_self.$props"
            :show-label="false"
          ></DsfTextProxy>
          <span v-if="value != ''">{{ append }}</span>
        </div>
        <slot name="error">
          <div
            v-if="errors.length>0"
            class="ds-error-text"
          >{{ errorsMsg }}</div>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfAuditState",
  ctrlCaption: "审核状态",
  mixins: [$mixins.formControl],
  props: {
    label:{
      type: String,
      default: "审核状态"
    },
    // 元数据
    metadata: {
      type: Object,
      default() {
        let md = dsf.metadata.get("items-meta-data");
        return md;
      },
    },
  },
  methods: {},
  created() {},
});
</script>